var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Marquee',{attrs:{"data":{ items: [{
    type: 'text',
    text: _vm.data.news.title,
    url: _vm.data.news.url,
  }], direction: 'ltr', background_color: _vm.data.background_color, color: _vm.data.color }}})
}
var staticRenderFns = []

export { render, staticRenderFns }